const GROUP_EMAIL_APIS = [
  "/common/hotel-detail",
  "/common/copy-hotel",
  "/core/api/v1/groupaccess/UpdateUser",
  "/core/api/v1/groupaccess/getUserRole",
  "/core/api/v1/reports/get-group-sales-statistics",
  "/core/api/v1/reports/get-group-roomrev-statistics",
  "/core/api/v1/reports/get-group-pickup-statistics",
  "/core/api/v1/reports/get-group-payment-statistics",
  "/core/api/v1/reports/get-group-tax-rp-statistics",
  "/core/api/v1/reports/check-if-group-reports-enabled",
  "/core/api/v1/account/get-single",
  "/core/api/v1/account/get-accountId",
  "/core/api/v1/account/get-csm-details",
  "/core/api/v1/account-ledger/get-account-balance",
  "/core/api/v1/payments/razorpay/capture-account-dues-payment",
  "/core/api/v1/account-ledger/download-invoice",
];

export default function setupAxios(axios, store) {
  const Spring = `${process.env.REACT_APP_SPRING_API_URL}`
  const Django = `${process.env.REACT_APP_API_URL}`

  axios.interceptors.request.use(
    (config) => {
      const { auth: { token, selectedHotel }, encryptedHotel } = store.getState();
      const isDjango = config.url.split("/")[0] === Django
      
      if (token) {
        config.headers.Authorization = token;
      }
      
      if (!config.params) { 
        config.params = {} 
      }
      
      const encryptedHotelIdEndpoints = [
        'v2/reports/generateDashDataLite',
        'v2/reports/getReportData',
        'v2/invoice/getHistoricalInvoices',
        'pos/OrderWiseSalesSummaryReportForParticularDay',
        'pos/CategorySummaryReport',
        'pos/hourlyItemSalesSummaryReport',
        'pos/allRestaurantDayWiseSalesSummary',

      ];
      
      // Check if the current API endpoint should use encrypted hotel ID
      const shouldUseEncryptedHotelId = encryptedHotelIdEndpoints.some(endpoint => 
        config.url.includes(endpoint)
      );
      
      if (shouldUseEncryptedHotelId && encryptedHotel?.encryptedHotelId) {
        config.params.hotel_id = encryptedHotel.encryptedHotelId;
        config.params.hotelId = encryptedHotel.encryptedHotelId;
      } else if (selectedHotel) {
        config.params.hotel_id = selectedHotel.hotelId;
        config.params.hotelId = selectedHotel.hotelId;
      }

      const url = config.url || "";
      const groupEmail = localStorage.getItem("groupEmail");
      const shouldAttachEmailId = GROUP_EMAIL_APIS.some((path) =>
        url.includes(path)
      );
      const emailIdAlreadyInUrl = /[?&]emailId=/.test(url);
      if (
        shouldAttachEmailId &&
        groupEmail &&
        groupEmail !== "null" &&
        groupEmail !== "undefined" &&
        !emailIdAlreadyInUrl &&
        !config.params?.emailId
      ) {
        if (!config.params) {
          config.params = {};
        }
        config.params.emailId = groupEmail;
      }
      
      return config;
    },
    err => Promise.reject(err)
  );
}
